/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Swal from 'sweetalert2';
import api from '../../../services/api';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import validaCNPJ from '../../../tools/validacoes/cnpj';
import validaCPF from '../../../tools/validacoes/cpf';
import validaEmail from '../../../tools/validacoes/email';
import MascaraTelefone from '../../../tools/mascaras/telefone';
import MascaraCNPJ from '../../../tools/mascaras/cnpj';
import MascaraCPF from '../../../tools/mascaras/cpf';
import MascaraCep from '../../../tools/mascaras/cep';
import somenteNumeros from '../../../tools/somenteNumeros';
import validaString from "../../../tools/validaString";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
    margin: theme.spacing(3),
    textAlign: 'center',
  },
  resetFont: {
    fontSize: '2rem',
    color: '#4BB543'
  },
  btnLogin: {
    fontSize: '2rem',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  ocultaCampo: {
    display: "none",
  },
  formControl: {
    width: "100%",
  }
}));

function getSteps() {
  return [
    'Informações do Usuário',
    'Informações da Empresa',
    'Endereço da Empresa',
    'Produto'
  ];
}

function FormEmpresa(props) {

  const { history } = props;
  const classes = useStyles();

  const [email, setEmail] = useState('');
  const [emailErro, setEmailErro] = useState(false);
  const [emailErroTexto, setEmailErroTexto] = useState('');

  const [nomeCompleto, setNomeCompleto] = useState('');
  const [nomeCompletoErro, setNomeCompletoErro] = useState(false);
  const [nomeCompletoErroTexto, setNomeCompletoErroTexto] = useState('');

  const [telefone, setTelefone] = useState('');
  const [telefoneErro, setTelefoneErro] = useState(false);
  const [telefoneErroTexto, setTelefoneErroTexto] = useState('');

  const [usuario, setUsuario] = useState('');
  const [usuarioErro, setUsuarioErro] = useState(false);
  const [usuarioErroTexto, setUsuarioErroTexto] = useState('');

  const [codigoUsuario, setCodigoUsuario] = useState(0);

  const [senha, setSenha] = useState('');
  const [senhaErro, setSenhaErro] = useState(false);
  const [senhaErroTexto, setSenhaErroTexto] = useState('');

  const [confirmacaoSenha, setConfirmacaoSenha] = useState('');
  const [confirmacaoSenhaErro, setConfirmacaoSenhaErro] = useState(false);
  const [confirmacaoSenhaErroTexto, setConfirmacaoSenhaErroTexto] = useState('');

  const [tipoPessoa, setTipoPessoa] = useState('J');
  // eslint-disable-next-line no-unused-vars
  const [tipoPessoaErro, setTipoPessoaErro] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tipoPessoaErroTexto, setTipoPessoaErroTexto] = useState('');

  const [cnpj, setCnpj] = useState('');
  const [cnpjErro, setCnpjErro] = useState(false);
  const [cnpjErroTexto, setCnpjErroTexto] = useState('');

  const [cpf, setCpf] = useState('');
  const [cpfErro, setCpfErro] = useState(false);
  const [cpfErroTexto, setCpfErroTexto] = useState('');

  const [nomeRazao, setNomeRazao] = useState('');
  const [nomeRazaoErro, setNomeRazaoErro] = useState(false);
  const [nomeRazaoErroTexto, setNomeRazaoErroTexto] = useState('');

  const [nomeFantasia, setNomeFantasia] = useState('');
  const [nomeFantasiaErro, setNomeFantasiaErro] = useState(false);
  const [nomeFantasiaErroTexto, setNomeFantasiaErroTexto] = useState('');

  const [inscricaoEstadual, setInscricaoEstadual] = useState('');
  const [inscricaoEstadualErro, setInscricaoEstadualErro] = useState(false);
  const [inscricaoEstadualErroTexto, setInscricaoEstadualErroTexto] = useState('');

  const [telefoneEmpresa, setTelefoneEmpresa] = useState('');
  const [telefoneEmpresaErro, setTelefoneEmpresaErro] = useState(false);
  const [telefoneEmpresaErroTexto, setTelefoneEmpresaErroTexto] = useState('');

  const [emailEmpresa, setEmailEmpresa] = useState('');
  const [emailEmpresaErro, setEmailEmpresaErro] = useState(false);
  const [emailEmpresaErroTexto, setEmailEmpresaErroTexto] = useState('');

  const [cep, setCep] = useState('');
  const [cepErro, setCepErro] = useState(false);
  const [cepErroTexto, setCepErroTexto] = useState('');

  const [rua, setRua] = useState('');
  const [ruaErro, setRuaErro] = useState(false);
  const [ruaErroTexto, setRuaErroTexto] = useState('');

  const [numero, setNumero] = useState('');
  const [numeroErro, setNumeroErro] = useState(false);
  const [numeroErroTexto, setNumeroErroTexto] = useState('');

  const [bairro, setBairro] = useState('');
  const [bairroErro, setBairroErro] = useState(false);
  const [bairroErroTexto, setBairroErroTexto] = useState('');

  const [complemento, setComplemento] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [complementoErro, setComplementoErro] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [complementoErroTexto, setComplementoErroTexto] = useState('');

  const [codigoCidade, setCodigoCidade] = useState('');
  const [cidadeErro, setCidadeErro] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [cidadeErroTexto, setCidadeErroTexto] = useState('')
  const [descricaoCidade, setDescricaoCidade] = useState('')

  const [produto, setProduto] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [produtoErro, setProdutoErro] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [produtoErroTexto, setProdutoErroTexto] = useState('');

  const [preco, setPreco] = useState('Selecione um Produto');
  const [statusContrato, setStatusContrato] = useState(false);


  const [produtos, setProdutos] = useState([]);

  const [labelNome, setLabelNome] = useState("Razão Social");
  const iframeContrato = useRef(null)

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  let camposErrados;

  useEffect(() => {

    async function carregarProdutos() {
      let itens = [];

      let dadosEnvio = {
        DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
        DBUSERNAME: localStorage.getItem("DBUSERNAME"),
        DBESQUEMA: localStorage.getItem("DBESQUEMA"),
        DBPID: localStorage.getItem("DBPID"),
        MANDNUMBER: localStorage.getItem("MANDNUMBER"),
        PROCNAME: 'VGWW_LISTA_SPACK_BASE64',
        PCCUPOM: ""
      };
      const resposta = await api.post('/execute/server', dadosEnvio);

      if (resposta.data.DATASET) {
        resposta.data.DATASET.map((item) => {
          return itens.push({
            codigo: item.CCDPACK,
            descricao: item.CDSPACK,
            mandante: item.CCDMANDA,
            precoUnitario: item.NPRUNIT,
            preco: item.PRECO,
            usuarioCriou: item.LCRIABYUSER,
            eula: item.CEULA,
            informacoesPublicas: item.CINFO_PUBLIC,
            diferimento: item.NTXDIFERIDO,
            valorPauta: item.NVLPAUTA
          });
        });
        setProdutos(itens);
      }
    }

    carregarProdutos();
  }, [])

  useEffect(() => {
    if (senha.length > 0) {
      if (senha.length < 7) {
        setSenhaErro(true);
        setSenhaErroTexto("Mínimo 7 caracteres")
      } else {
        setSenhaErro(false);
      }
      if (senha !== confirmacaoSenha) {
        setConfirmacaoSenhaErro(true);
        setConfirmacaoSenhaErroTexto("Confirmação diferente da senha");
      } else {
        setConfirmacaoSenhaErro(false);
      }
    }

  }, [confirmacaoSenha, senha])

  useEffect(() => {
    if (tipoPessoa !== 'J') {
      setLabelNome("Nome");
      setCpf('');
    } else {
      setLabelNome("Razão Social");
      setCnpj('');
    }
  }, [tipoPessoa]);

  useEffect(() => {
    if (somenteNumeros(cep).length === 8) {
      buscarPorCep(cep);
    }
  }, [cep])

  async function criaUsuario() {

    let dadosUsuario = {
      PCCDLOGIN: 0,
      PLOGIN: usuario.toUpperCase(),
      PMAIL: email.toUpperCase(),
      PSENHA: senha,
      PNOMEUSER: nomeCompleto.toUpperCase(),
      PFONE: somenteNumeros(telefone),
      PROCNAME: "VGWW_VALIDAEINSERE_LOGIN"
    }

    const resposta = await api.post('/execute/server', dadosUsuario);


    if (resposta.status === 200) {
      if (resposta.data.PMSG.length > 0) {
        Swal.fire({
          type: 'error',
          html: resposta.data.PMSG,
        });
        return false;
      } else {
        setCodigoUsuario(resposta.data.PCCDLOGIN);
        return true;
      }
    } else {
      return false;
    }

  }

  async function validaCnpjCpfBase() {

    let dadosDocumentoEmpresa = {
      PCCDPESS: 0,
      PCNPJ: tipoPessoa === 'J' ? cnpj : "",
      PCPF: tipoPessoa === 'F' ? cpf : "",
      PROCNAME: "VGWW_VALIDA_CADPESSOA"

    }

    const resposta = await api.post('/execute/server', dadosDocumentoEmpresa);

    if (resposta.status === 200) {
      if (resposta.data.PMSG.length > 0) {
        Swal.fire({
          type: 'error',
          html: resposta.data.PMSG,
        });
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }

  }

  const handleProduto = (event, key) => {
    setStatusContrato(false);
    setPreco(produtos[key.key].preco);
    setProduto(event.target.value);
    iframeContrato.current.src = "data:text/html;charset=utf-8," + encodeURIComponent(window.atob(produtos[key.key].eula));
  };

  function getStepContent(step) {
    // eslint-disable-next-line default-case
    switch (step) {
      case 0: return <>
        <TextField
          className={classes.textField}
          label="E-Mail *"
          error={emailErro}
          helperText={emailErro ? emailErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onBlur={() => {
            if (validaEmail(email)) {
              setEmailErro(false);
            } else {
              setEmailErro(true);
              setEmailErroTexto("Informe E-mail Valido");
            }
          }}
        />

        <TextField
          className={classes.textField}
          label="Nome Completo *"
          error={nomeCompletoErro}
          helperText={nomeCompletoErro ? nomeCompletoErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={nomeCompleto}
          onChange={e => setNomeCompleto(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Fone / Celular *"
          error={telefoneErro}
          helperText={telefoneErro ? telefoneErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={telefone}
          onChange={e => setTelefone(e.target.value)}
          InputProps={{
            inputComponent: MascaraTelefone,
          }}
        />

        <TextField
          className={classes.textField}
          label="Usuário *"
          error={usuarioErro}
          helperText={usuarioErro ? usuarioErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={usuario}
          onChange={e => setUsuario(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Senha *"
          error={senhaErro}
          type="password"
          helperText={senhaErro ? senhaErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={senha}
          onChange={e => setSenha(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Confirmação Senha *"
          error={confirmacaoSenhaErro}
          type="password"
          helperText={confirmacaoSenhaErro ? confirmacaoSenhaErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={confirmacaoSenha}
          onChange={e => setConfirmacaoSenha(e.target.value)}
        />


      </>
        ;
      case 1: return <>
        <FormControl variant="outlined"
          className={classes.formControl}>
          <InputLabel >
            Tipo Pessoa
          </InputLabel>
          <Select
            error={tipoPessoaErro}
            helperText={tipoPessoaErroTexto}
            fullWidth
            value={tipoPessoa}
            onChange={e => setTipoPessoa(e.target.value)}
          >
            <MenuItem value={'F'}>Física</MenuItem>
            <MenuItem value={'J'}>Jurídica</MenuItem>
          </Select>
        </FormControl>

        <TextField
          className={tipoPessoa === 'J' ? classes.textField : classes.ocultaCampo}
          label="CNPJ *"
          error={cnpjErro}
          helperText={cnpjErro ? cnpjErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={cnpj}
          onChange={e => setCnpj(e.target.value)}
          onBlur={() => {
            if (validaCNPJ(cnpj)) {
              setCnpjErro(false);
            } else {
              setCnpjErro(true);
              setCnpjErroTexto('Inform um CNPJ Valido');
            }
          }}
          InputProps={{
            inputComponent: MascaraCNPJ,
          }}
        />

        <TextField
          className={tipoPessoa === 'F' ? classes.textField : classes.ocultaCampo}
          label="CPF *"
          error={cpfErro}
          helperText={cpfErro ? cpfErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={cpf}
          onChange={e => setCpf(e.target.value)}
          InputProps={{
            inputComponent: MascaraCPF,
          }}
          onBlur={() => {
            if (validaCPF(cpf)) {
              setCpfErro(false);
            } else {
              setCpfErro(true);
              setCpfErroTexto('Inform um CPF Valido');
            }
          }}
        />

        <TextField
          className={classes.textField}
          label="Inscrição Estadual *"
          error={inscricaoEstadualErro}
          helperText={inscricaoEstadualErro ? inscricaoEstadualErroTexto : ''}
          fullWidth
          type='number'
          margin="normal"
          variant="outlined"
          value={inscricaoEstadual}
          onChange={e => setInscricaoEstadual(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label={labelNome}
          error={nomeRazaoErro}
          helperText={nomeRazaoErro ? nomeRazaoErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={nomeRazao}
          onChange={e => setNomeRazao(e.target.value)}
        />

        <TextField
          className={tipoPessoa === 'J' ? classes.textField : classes.ocultaCampo}
          label="Fantasia *"
          error={nomeFantasiaErro}
          helperText={nomeFantasiaErro ? nomeFantasiaErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={nomeFantasia}
          onChange={e => setNomeFantasia(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Telefone *"
          error={telefoneEmpresaErro}
          helperText={telefoneEmpresaErro ? telefoneEmpresaErroTexto : ''}
          margin="normal"
          fullWidth
          variant="outlined"
          value={telefoneEmpresa}
          onChange={e => setTelefoneEmpresa(e.target.value)}
          InputProps={{
            inputComponent: MascaraTelefone,
          }}
        />

        <TextField
          className={classes.textField}
          label="E-Mail *"
          error={emailEmpresaErro}
          helperText={emailEmpresaErro ? emailEmpresaErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={emailEmpresa}
          onChange={e => setEmailEmpresa(e.target.value)}
          onBlur={() => {
            if (validaEmail(email)) {
              setEmailEmpresaErro(false);
            } else {
              setEmailEmpresaErro(true);
              setEmailEmpresaErroTexto("Informe E-mail Valido");
            }
          }}
        />

      </>;
      case 2: return <>
        <TextField
          className={classes.textField}
          label="CEP *"
          error={cepErro}
          helperText={cepErro ? cepErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={cep}
          InputProps={{
            inputComponent: MascaraCep,
          }}
          onChange={e => setCep(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Rua *"
          error={ruaErro}
          helperText={ruaErro ? ruaErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={rua}
          onChange={e => validaString(setRua,60,e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Numero *"
          error={numeroErro}
          helperText={numeroErro ? numeroErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={numero}
          onChange={e => validaString(setNumero, 7, e.target.value)}
          
        />

        <TextField
          className={classes.textField}
          label="Bairro *"
          error={bairroErro}
          helperText={bairroErro ? bairroErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={bairro}
          onChange={e => setBairro(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Complemento"
          error={complementoErro}
          helperText={complementoErro ? complementoErroTexto : ''}
          fullWidth
          margin="normal"
          variant="outlined"
          value={complemento}
          onChange={e => setComplemento(e.target.value)}
        />

        <TextField
          className={classes.textField}
          label="Cidade *"
          error={cidadeErro}
          helperText={cidadeErro ? cidadeErroTexto : ''}
          fullWidth
          disabled
          margin="normal"
          variant="outlined"
          value={descricaoCidade}
        />
      </>;
      case 3: return <>
        <FormControl variant="outlined"
          className={classes.formControl}>
          <InputLabel >
            Produtos
          </InputLabel>
          <Select
            value={produto}
            error={produtoErro}
            helperText={produtoErroTexto}
            onChange={handleProduto}
            fullWidth
          >
            {produtos.map((produto, index) => (
              <MenuItem key={index} value={produto.codigo}>{produto.descricao}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <h5>{preco}</h5>
        <iframe ref={iframeContrato}>
        </iframe>

        <FormControlLabel
          control={<Checkbox checked={statusContrato} onChange={e => setStatusContrato(e.target.checked)} />}
          label="Aceito"
        />

      </>;
    }
  }

  const handleNext = async () => {

    // return setActiveStep((prevActiveStep) => prevActiveStep + 1);
    let irProximo = false;
    if (validarCampos()) {
      if (activeStep === 0) {
        irProximo = true;
        // irProximo = await criaUsuario();
      }

      if (activeStep === 1) {
        irProximo = true;
        // irProximo = await validaCnpjCpfBase();
      }

      if (activeStep === 2) {
        irProximo = true;
      }

      if (activeStep === 3) {
        Swal.fire({
          title: 'Aguarde um momento !',
          html: 'Cadastrando empresa ...',// add html attribute if you want or remove
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        });
        let dadosNovaEmpresa = {
          PCCDLOGIN: codigoUsuario, //código que retornou do método AddLogin
          PCCDPESS: 0, //sempre passar o valor zero no envio
          PCRZPESS: nomeRazao.toUpperCase(),
          PCDSPESS: tipoPessoa === 'J' ? nomeFantasia.toUpperCase() : nomeRazao.toUpperCase(),
          PCPESSOA: tipoPessoa, //J - se for informar CNPJ/IE e F - se for CPF
          PCNPJ: tipoPessoa === 'J' ? somenteNumeros(cnpj) : 0,
          PCCPF: tipoPessoa === 'F' ? somenteNumeros(cpf) : 0,
          PCIE: somenteNumeros(inscricaoEstadual),
          PCCEP: somenteNumeros(cep),
          PCCDCIDADE: codigoCidade,
          PCRUA: rua.toUpperCase(),
          PNR: numero,
          PCBAIRRO: bairro.toUpperCase(),
          PCOMPLEMENTO: complemento.toUpperCase(),
          PCEMAIL: emailEmpresa.toUpperCase(),
          PCFONE: somenteNumeros(telefoneEmpresa),
          PCCDMANDA: 1, //sempre passar o valor 1 neste método, mandante da base GWW
          PCNRCTOI: 0, //sempre passar o valor zero no envio
          PCCDPACK: produto, //código do pacote que o cliente selecionou no método GetPacotesDisp
          PCCDCONDIV: 0,
          PMODO: "I", //sempre passar o valor i (maiúsculo)
          PSENHA: senha, //mesma senha que foi passada no método AddLogin
          PROCNAME: "VGWW_PESSOA_ADD_V2"
        }

        const resposta = await api.post('/execute/server', dadosNovaEmpresa);
        console.log('resposta',resposta);
        if (resposta.status === 200) {
          if (resposta.data.PMSG.includes('Erro')) {
            Swal.fire({
              type: 'error',
              html: resposta.data.PMSG,
            });
            irProximo = false;
          } else {
            Swal.fire({
              type: 'success',
              html: resposta.data.PMSG,
            });
            irProximo = true;
          }
        } else {
          irProximo = false;
        }


      }

      if (irProximo) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }


  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function vaiLogin() {
    console.log('history', history, props)
    history.push("/");
  }
  function validarCampos() {

    camposErrados = [];

    if (activeStep === 0) {
      if (email === '') {
        setEmailErro(true);
        setEmailErroTexto("Campo obrigatorio");
        camposErrados.push("E-Mail");
      } else {
        if (validaEmail(email)) {
          setEmailErro(false);
        } else {
          setEmailErro(true);
          setEmailErroTexto("Informe E-mail Valido");
          camposErrados.push("E-Mail");
        }
      }

      if (nomeCompleto === '') {
        setNomeCompletoErro(true);
        setNomeCompletoErroTexto("Campo obrigatorio");
        camposErrados.push("Nome Completo");
      } else {
        setNomeCompletoErro(false);
      }

      if (telefone === '') {
        setTelefoneErro(true);
        setTelefoneErroTexto("Campo obrigatorio");
        camposErrados.push("Telefone");
      } else {
        setTelefoneErro(false);
      }

      if (usuario === '') {
        setUsuarioErro(true);
        setUsuarioErroTexto("Campo obrigatorio");
        camposErrados.push("Usuário");
      } else {
        setUsuarioErro(false);
      }

      if (senha === '') {
        setSenhaErro(true);
        setSenhaErroTexto("Campo obrigatorio");
        camposErrados.push("Senha");
      } else if (senha.length < 7) {
        setSenhaErro(true);
        setSenhaErroTexto("Mínimo 7 Caracteres");
        camposErrados.push("Senha");
      } else {
        setSenhaErro(false);
      }


      if (confirmacaoSenha === '') {
        setConfirmacaoSenhaErro(true);
        setConfirmacaoSenhaErroTexto("Campo obrigatorio");
        camposErrados.push("Confirmação de Senha");
      } else {
        setConfirmacaoSenhaErro(false);
        if (senha !== confirmacaoSenha) {
          setConfirmacaoSenhaErro(true);
          setConfirmacaoSenhaErroTexto("Confirmação diferente da senha");
          camposErrados.push("Confirmação de Senha");
        }
      }

    }

    if (activeStep === 1) {
      if (tipoPessoa === 'J') {
        if (cnpj.length > 0) {
          if (validaCNPJ(cnpj)) {
            setCnpjErro(false);
          } else {
            setCnpjErro(true);
            setCnpjErroTexto('Inform um CNPJ Valido');
            camposErrados.push('CNPJ');
          }
        } else {
          setCnpjErro(true);
          setCnpjErroTexto('Campo Obrigatorio');
          camposErrados.push('CNPJ');
        }
      }

      if (tipoPessoa === 'F') {
        if (cpf.length > 0) {
          if (validaCPF(cpf)) {
            setCpfErro(false);
          } else {
            setCpfErro(true);
            setCpfErroTexto('Informe um CPF Valido');
            camposErrados.push('CPF');
          }
        } else {
          setCpfErro(true);
          setCpfErroTexto('Campo Obrigatorio');
          camposErrados.push('CPF');
        }
      }

      if (inscricaoEstadual === '') {
        setInscricaoEstadualErro(true);
        setInscricaoEstadualErroTexto("Campo obrigatorio");
        camposErrados.push("Inscrição Estadual");
      } else {
        setInscricaoEstadualErro(false);
      }

      if (nomeRazao === '') {
        setNomeRazaoErro(true);
        setNomeRazaoErroTexto("Campo obrigatorio");
        camposErrados.push(labelNome);
      } else {
        setNomeRazaoErro(false);
      }

      if (tipoPessoa === 'J') {
        if (nomeFantasia === '') {
          setNomeFantasiaErro(true);
          setNomeFantasiaErroTexto("Campo obrigatorio");
          camposErrados.push("Nome Fantasia");
        } else {
          setNomeFantasiaErro(false);
        }
      }

      if (telefoneEmpresa === '') {
        setTelefoneEmpresaErro(true);
        setTelefoneEmpresaErroTexto("Campo obrigatorio");
        camposErrados.push("Telefone");
      } else {
        setTelefoneEmpresaErro(false);
      }

      if (emailEmpresa === '') {
        setEmailEmpresaErro(true);
        setEmailEmpresaErroTexto("Campo obrigatorio");
        camposErrados.push("E-Mail");
      } else {
        if (validaEmail(emailEmpresa)) {
          setEmailEmpresaErro(false);
        } else {
          setEmailEmpresaErro(true);
          setEmailEmpresaErroTexto("Informe E-mail Valido");
          camposErrados.push("E-Mail");
        }
      }


    }

    if (activeStep === 2) {
      if (cep === '') {
        setCepErro(true);
        setCepErroTexto("Campo obrigatorio");
        camposErrados.push("CEP");
      } else {
        setCepErro(false);
      }

      if (rua === '') {
        setRuaErro(true);
        setRuaErroTexto("Campo obrigatorio");
        camposErrados.push("Rua");
      } else {
        setRuaErro(false);
      }

      if (numero === '') {
        setNumeroErro(true);
        setNumeroErroTexto("Campo obrigatorio");
        camposErrados.push("Numero");
      } else {
        setNumeroErro(false);
      }

      if (bairro === '') {
        setBairroErro(true);
        setBairroErroTexto("Campo obrigatorio");
        camposErrados.push("Bairro");
      } else {
        setBairroErro(false);
      }

      if (codigoCidade === '') {
        setCidadeErro(true);
        setCidadeErroTexto("Campo obrigatorio");
        camposErrados.push("Cidade");
      } else {
        setCidadeErro(false);
      }

    }

    if (activeStep === 3) {
      if (!statusContrato) {
        camposErrados.push("Marque o Campo Aceite do Contrato");
      }


      if (!produto) {
        camposErrados.push("Selecione um Produto");
      }
    }



    if (camposErrados.length === 0) {
      return true;
    } else {
      Swal.fire({
        type: 'error',
        title: 'Campos Inválidos',
        html: `<lu>` +
          camposErrados.map(campoErrado => (
            `<li>${campoErrado}</li>`
          )) +
          `</lu>`
      });
      return false;
    }

  };

  async function buscarPorCep(cep) {
    const retorno = await api.get(`https://viacep.com.br/ws/${cep}/json/`);
    setCepErro(false);
    setCepErroTexto('');
    if (retorno.data.erro) {
      setRua('');
      setBairro('');
      setCodigoCidade('');
      setCepErro(true);
      setCepErroTexto('Cep inexistente na base nacional.');
    }
    setRua(retorno.data.logradouro);
    setBairro(retorno.data.bairro);
    setCodigoCidade(retorno.data.ibge);
    setDescricaoCidade(retorno.data.localidade);
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography>{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <Grid container>
                  <Grid item xs={6}>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.button}
                      fullWidth
                    >
                      Voltar
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                      fullWidth
                    >
                      {activeStep === steps.length - 1 ? 'Finalizar' : 'Próximo'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={1} className={classes.resetContainer} >
          <Typography className={classes.resetFont}>Empresa cadastrada com sucesso !</Typography>
          <Typography>Volta a tela de login para acessar o emissor.</Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.button}
            onClick={vaiLogin}
          >
            Login
              </Button>
        </Paper>
      )}
    </div>
  );
}


export default withRouter(FormEmpresa);